
import { getStayRoomPrice, saveStayRoomPrice } from '@/api/stayRoomPrice';
import { Component, Vue } from 'vue-property-decorator';
import RoomPriceForm from './components/RoomPriceForm.vue';
import PricePartForm from './components/PricePartForm.vue';
import BasicPriceUpdate from './components/BasicPriceUpdate.vue';
import Calendar from '@/components/Calendar/index.vue';

@Component({
  components: {
    RoomPriceForm,
    PricePartForm,
    BasicPriceUpdate,
    Calendar,
  },
})
export default class extends Vue {
  mounted() {
    this.getStayRoomPrice();
  }

  private priceInfo: any = {
    basicPriceList: [],
    pricePartList: [],
  }

  private selectedPricePart = {
    name: '',
    startDate: '',
    endDate: '',
  };

  private selectedPricePartIndex: any = null;

  private activeTab = 'basic';

  private loading = true;

  private basicUpdateVisible = false;

  private optionSelectVisible = false;

  private getStayRoomPrice() {
    getStayRoomPrice().then((res) => {
      this.priceInfo = res.data;
      this.loading = false;
    });
  }

  private pricePartFormVisible = false;

  private handleVisiblePricePartForm(index: any) {
    this.selectedPricePartIndex = index;
    if (index !== null) {
      this.selectedPricePart = this.priceInfo.pricePartList[index];
    } else {
      this.selectedPricePart = {
        name: '',
        startDate: '',
        endDate: '',
      };
    }
    this.pricePartFormVisible = !this.pricePartFormVisible;
  }

  private handleSaveStayRoomPrice() {
    this.$confirm('요금 정보를 저장하시겠습니까?', '요금정보 저장', {
      confirmButtonText: '저장',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      this.loading = true;
      saveStayRoomPrice(this.priceInfo).then(() => {
        this.$message.success('요금 정보를 저장했습니다.');
        this.getStayRoomPrice();
      }).catch(() => {
        this.loading = false;
        this.$message.error('요금 정보를 저장하는데 실패했습니다.');
      });
    });
  }

  private handleAddTypePrice() {
    this.$confirm('', '요금정보 저장', {
      confirmButtonText: '저장',
      showCancelButton: false, // 취소 버튼 표시하지 않음
      type: 'info',
    }).then(() => {
      // 확인 버튼이 눌렸을 때의 로직을 여기에 작성
      // 다이얼로그를 닫거나 추가적인 작업을 수행할 수 있습니다.
    });

    this.optionSelectVisible = !this.optionSelectVisible; // 다이얼로그를 토글
  }

  private handleVisibleBasicUpdate() {
    this.basicUpdateVisible = !this.basicUpdateVisible;
  }

  private handleSuccessBasicUpdate(form: any) {
    this.handleVisibleBasicUpdate();
    const lastBasicPrice = this.priceInfo.basicPriceList[this.priceInfo.basicPriceList.length - 1];

    if (lastBasicPrice) {
      const roomPrices: any = [];
      lastBasicPrice.roomPrices.forEach((roomPrice: any) => {
        roomPrices.push({
          ...roomPrice,
          idx: null,
          useStatus: false,
        });
      });

      const basicPriceUpdate: any = {
        ...form,
        roomPrices,
      };
      this.priceInfo.basicPriceList.push(basicPriceUpdate);
      this.$message.success('기본요금 업데이트 예정이 추가되었습니다.');
    } else {
      this.$message.error('기본요금 업데이트 예정에 실패했습니다.');
    }
  }

  // private handleDeletePricePart(index: number) {
  //   const pricePart = this.priceInfo.pricePartList[index];
  //   this.$confirm(`정말 ${pricePart.name}(${pricePart.startDate} ~ ${pricePart.endDate}) 일정을 삭제하시겠습니까?`, '일정유형 삭제', {
  //     confirmButtonText: '삭제',
  //     cancelButtonText: '취소',
  //     type: 'info',
  //   }).then(() => {
  //     this.$message.success('일정이 삭제되었습니다.');
  //     this.priceInfo.pricePartList.splice(index, 1);
  //   });
  // }

  private handleDeleteBasicPrice(index: number) {
    const basicPrice = this.priceInfo.basicPriceList[index];
    this.$confirm(`정말 기본요금(${basicPrice.basicUpdateDate}) 업데이트 일정을 삭제하시겠습니까?`, '일정유형 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      this.$message.success('기본요금이 삭제되었습니다.');
      this.priceInfo.basicPriceList.splice(index, 1);
    });
  }

  /* eslint-disable */
  private handleSavePricePart(form: any) {
    if (this.selectedPricePartIndex !== null) {
      this.priceInfo.pricePartList[this.selectedPricePartIndex] = {
        ...this.priceInfo.pricePartList[this.selectedPricePartIndex],
        ...form,
      };
    } else {
      let roomPrices: any = [];
      if (this.priceInfo.pricePartList.length > 0) {
        this.priceInfo.pricePartList[this.priceInfo.pricePartList.length - 1].roomPrices.forEach((roomPrice: any) => {
          roomPrices.push({
            ...roomPrice,
            useStatus: false,
            idx: null,
          });
        });
      } else {
        this.priceInfo.basicPriceList[this.priceInfo.basicPriceList.length - 1].roomPrices.forEach((roomPrice: any) => {
          roomPrices.push({
            ...roomPrice,
            useStatus: false,
            idx: null,
          });
        });
      }
      this.priceInfo.pricePartList.push({
        ...form,
        roomPrices: roomPrices,
      });
    }
    this.pricePartFormVisible = !this.pricePartFormVisible;
    /* eslint-enable */
  }

  private addPriceType() {
    this.priceTypeList.push({ idx: 4, name: '', daterange: [] });
  }

  private deletePriceType(item: any) {
    this.$confirm(`정말 '${item.name}' 타입을 삭제하시겠습니까?`, '요금 타입 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
    }).then(() => {
      for (let i = 0; i < this.priceTypeList.length; i += 1) {
        if (this.priceTypeList[i].idx === item.idx) {
          this.priceTypeList.splice(i, 1);
        }
      }
      this.$message.success('삭제했습니다.');
    });
  }

  private priceTypeList = [
    {
      idx: 1,
      name: '기본요금',
      daterange: ['2024-01-04', '2024-01-04'],
    },
    {
      idx: 2,
      name: '준성수기',
      daterange: ['2024-02-04', '2024-03-04'],
    },
    {
      idx: 3,
      name: '성수기',
      daterange: ['2024-04-04', '2024-05-04'],
    },
  ]

  private tableDataList = [
    {
      idx: 1,
      name: 'room1',
      selectedOption: 'option1',
      telChecked: false,
      optionList: {
        option1: [
          {
            idx: 1,
            name: '기본요금',
            normal: '20,000',
            fri: '50,000',
            sat: '30,000',
            holiday: '40,000',
            holidayAll: '40,000',
          },
          {
            idx: 2,
            name: '준성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
          {
            idx: 3,
            name: '성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
        ],
        option2: [
          {
            idx: 4,
            name: '기본요금',
            normal: '10,000',
            fri: '20,000',
            sat: '30,000',
            holiday: '40,000',
            holidayAll: '50,000',
          },
          {
            idx: 5,
            name: '준성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
          {
            idx: 6,
            name: '성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
        ],
      },
    },
    {
      idx: 2,
      name: 'room2',
      selectedOption: 'option4',
      telChecked: true,
      optionList: {
        option3: [
          {
            idx: 7,
            name: '기본요금',
            fri: '20,000',
            sat: '30,000',
            holidayAll: '50,000',
          },
          {
            idx: 8,
            name: '준성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
          {
            idx: 9,
            name: '성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
        ],
        option4: [
          {
            idx: 10,
            name: '기본요금',
            normal: '10,000',
            fri: '10,000',
            sat: '20,000',
            holiday: '20,000',
            holidayAll: '30,000',
          },
          {
            idx: 11,
            name: '준성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
          {
            idx: 12,
            name: '성수기',
            normal: '100,000',
            fri: '100,000',
            sat: '100,000',
            holiday: '100,000',
            holidayAll: '100,000',
          },
        ],
      },
    },
  ]

  private HandleOptionChange(roomId: any) {
    console.log(roomId);
    // this.tableData = ;
  }

  private todayYear = new Date().getFullYear();

  private todayMonth = new Date().getMonth() + 1;

  private changeBtn = false;

  private today = new Date();

  private clickPrevMonth() {
    if (!this.changeBtn) {
      if (this.todayMonth === 1) this.today = new Date(this.today.getFullYear() - 1, this.todayMonth - 1, this.today.getDate());
      else this.today = new Date(this.today.getFullYear(), this.todayMonth - 1, this.today.getDate());
    }
    this.changeCalendar(this.today);
  }

  private clickNextMonth() {
    if (!this.changeBtn) {
      if (this.todayMonth === 11) this.today = new Date(this.today.getFullYear() - 1, this.todayMonth + 1, this.today.getDate());
      else this.today = new Date(this.today.getFullYear(), this.todayMonth + 1, this.today.getDate());
    }
    this.changeCalendar(this.today);
  }

  private changeCalendar(today: any) {
    this.todayYear = today.getFullYear();
    if (this.changeBtn) {
      this.todayMonth = today.getMonth() + 1;
      this.today = new Date(this.today.getFullYear(), this.todayMonth, this.today.getDate());
    } else this.todayMonth = today.getMonth();
    if (this.todayMonth === 0) this.todayMonth = 12;
    this.changeBtn = false;
  }

  // private pricePartFormVisible = false;

  // private handleVisiblePricePartForm() {
  //   this.pricePartFormVisible = !this.pricePartFormVisible;
  // }

  // private handleSavePricePartList(pricePartList: any) {
  //   this.handleVisiblePricePartForm();
  //   pricePartList.forEach((pricePart: any, index: number) => {
  //     this.priceInfo.pricePartList = pricePartList;
  //     this.priceInfo.roomList.forEach((room: any) => {
  //       if (room.prices.length > index + 1) {
  //         room.prices[index].pricePartName = pricePart.name;
  //       } else {
  //         room.prices.push({
  //           pricePartName: pricePart.name,
  //           weekdayPrice: 0,
  //           fridayPrice: 0,
  //           saturdayPrice: 0,
  //           holidayPrice: 0,
  //           holidayBeforePrice: 0,
  //         });
  //       }
  //     });
  //   });
  // }

  private handleDeletePricePart(index: number) {
    this.priceInfo.pricePartList.splice(index, 1);
    this.priceInfo.roomList.forEach((room: any) => {
      room.prices.splice(index + 1, 1);
    });
  }

  data() {
    return {
      checked: false,

      options: [
        {
          value: 'Option1',
          label: '테스트1',
        },
        {
          value: 'Option2',
          label: '테스트2',
        },
      ],
      handleAddTypePrice: false,
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },

      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: 'Last month',
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: 'Last 3 months',
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        },
        ],
      },
      value1: '',
      value2: '',
    };
  }
}
